import { theme } from "antd";
import Icon, { BarChartOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SparkleIcon } from "src/components/SparkleIcon";
import { useColorScheme } from "src/hooks/useColorScheme";

export function RiskTag() {
  const { token } = theme.useToken();
  return (
    <Icon
      title="Risk"
      component={() => (
        <span style={{ color: token.volcano6 }}>
          <SparkleIcon size={12} style={{ color: token.volcano6 }} />
        </span>
      )}
    />
  );
}

export function SummaryTag() {
  const { token } = theme.useToken();
  const mode = useColorScheme();
  return (
    <InfoCircleOutlined
      title="Summary"
      style={{ color: mode === "dark" ? token.purple9 : token.purple4 }}
    />
  );
}

export function MetricTag() {
  const { token } = theme.useToken();
  return <BarChartOutlined title="Metric" style={{ color: token.lime7 }} />;
}
